var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "missing-fields-tooltip",
    { attrs: { "missing-fields-list": _vm.listMissingFields } },
    [
      _c(
        "v-btn",
        {
          key: _vm.buttonkey,
          class: {
            normal: _vm.type === "normal",
            cancel: _vm.type === "cancel",
            disabled: _vm.disabled
          },
          style: [
            _vm.defaultButtonStyling,
            _vm.buttonStyling,
            {
              height: _vm.height,
              width: _vm.width,
              maxWidth: _vm.width,
              backgroundColor: _vm.buttonColor,
              color: _vm.labelColor
            }
          ],
          attrs: { disabled: _vm.disabled, loading: _vm.isLoading },
          on: {
            "~click": function($event) {
              return _vm.click.apply(null, arguments)
            }
          }
        },
        [
          _vm._t("default"),
          _vm._v(" "),
          !!_vm.icon && _vm.iconSide === "left"
            ? _c(
                "v-icon",
                { attrs: { size: _vm.iconSize, color: _vm.iconColor } },
                [_vm._v("\n      " + _vm._s(_vm.icon) + "\n    ")]
              )
            : _vm._e(),
          _vm._v(" "),
          !!_vm.label
            ? _c(
                "span",
                {
                  staticClass: "button-label",
                  class: { "show-only-on-hover": _vm.showLabelOnHover },
                  style: {
                    color: _vm.labelColor,
                    "margin-left": !!_vm.icon ? "4px" : "0"
                  }
                },
                [_vm._v("\n      " + _vm._s(_vm.label) + "\n    ")]
              )
            : _vm._e(),
          _vm._v(" "),
          !!_vm.icon && _vm.iconSide === "right"
            ? _c(
                "v-icon",
                { attrs: { size: _vm.iconSize, color: _vm.iconColor } },
                [_vm._v("\n      " + _vm._s(_vm.icon) + "\n    ")]
              )
            : _vm._e()
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-211f1a4d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-211f1a4d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/newComponents/_Atoms/CustomButton.vue
// module id = null
// module chunks = 